<template>
  <div style="z-index: 2;">
    <ControlBar />
    <ToolBar v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
import ControlBar from "@/components/vjmapUtil/ControlBar";
import ToolBar from "@/components/vjmapUtil/ToolBar";
export default {
  name: "UILayer",
  components: {
    ControlBar,
    ToolBar
  },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/vjmapUtil/UILayer.vue